import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface CriSectionProps {
  alternate?: boolean;
  children: React.ReactNode;
}

const CriSection: React.FC<CriSectionProps> = ({
  alternate = false,
  children,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        backgroundColor: alternate
          ? theme.palette.secondaryBackground.main
          : theme.palette.background.default,
        alignItems: "center",
        paddingTop: {
          xs: "36px",
          md: "74px",
        },
        paddingBottom: {
          xs: "36px",
          md: "74px",
        },
        paddingLeft: {
          xs: "24px",
          md: 0,
        },
        paddingRight: {
          xs: "24px",
          md: 0,
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1000px",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default CriSection;
